"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _DownloadLinkBox = _interopRequireDefault(require("../../DownloadLinkBox/DownloadLinkBox"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n";
  const fileName = "InAppFachvereine_InAppFachvereine";
  const element = document.querySelector("style[data-sass-component='InAppFachvereine_InAppFachvereine']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const InAppFachvereine = _ref => {
  let {
    translate,
    lang,
    data
  } = _ref;
  const items = data?.filter(el => el.website)?.map(el => {
    return {
      paragraph_type: 'link_box',
      link: {
        original_url: el.website,
        url: el.website,
        title: `${el.code} - ${el.name}`
      }
    };
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "inapp-fachvereine-container sia-padding-02-bottom sia-margin-03-top"
  }, items && /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
    items: items,
    lang: lang,
    translate: translate,
    isCMS: false
  }));
};
InAppFachvereine.propTypes = {
  translate: _propTypes.default.func.isRequired,
  lang: _propTypes.default.string.isRequired,
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number.isRequired,
    code: _propTypes.default.string.isRequired,
    name: _propTypes.default.string.isRequired,
    website: _propTypes.default.string
  })).isRequired
};
var _default = exports.default = InAppFachvereine;